import { Schema } from 'mongoose';
import GeoPoint, { IGeoPoint } from './geo-point';
// tslint:disable-next-line no-var-requires
const countryCodesAlpha2 = require('../services/country-codes-alpha2.json');

export interface IServiceLocation {
  line1?: string;
  line2?: string;
  postcode?: string;
  city?: string;
  state?: string;
  countryCode: string;
  geo: IGeoPoint;
  formattedAddress?: string;
}
const serviceLocation = new Schema(
  {
    line1: {
      type: String,
      required: false,
    },
    line2: {
      type: String,
      required: false,
    },
    postcode: {
      type: String,
      required: false,
    },
    city: {
      type: String,
      required: false,
    },
    state: {
      type: String,
      required: false,
    },
    countryCode: {
      type: String,
      required: true,
      enum: countryCodesAlpha2,
    },
    geo: {
      type: GeoPoint,
      required: true,
    },
    formattedAddress: {
      type: String,
      required: false,
    },
  },
  { _id: false, toJSON: { virtuals: true }, toObject: { virtuals: true } },
);

// we store only the countryCode in this model
// but when called with populate(), we retrieve the country name along with all other details
serviceLocation.virtual('country', {
  ref: 'Country',
  localField: 'countryCode',
  foreignField: 'countryCode',
  justOne: true,
});

export default serviceLocation;
